import { tableOptionsToFirstPage } from '@/store/modules/StateUtil';

export const serviceIndexState = {
    namespaced: true,
    state: {
        dateRange: {
            startDate: null,
            endDate: null,
        },
        filterText: null,
        filterDevice: null,
        filterDoneByUser: null,

        tableOptions: {
            page: 1,
            itemsPerPage: 30,
            sortBy: ['created'],
            sortDesc: [false],
            mustSort: true,
            multiSort: false,
        },
    },
    mutations: {
        setDateRange(state, dateRange) {
            state.dateRange = dateRange;
            state.tableOptions = tableOptionsToFirstPage(state);
        },
        setFilterText(state, filterText) {
            state.filterText = filterText;
            state.tableOptions = tableOptionsToFirstPage(state);
        },
        setFilterDevice(state, filterDevice) {
            state.filterDevice = filterDevice;
            state.tableOptions = tableOptionsToFirstPage(state);
        },
        setFilterDoneByUser(state, filterDoneByUser) {
            state.filterDoneByUser = filterDoneByUser;
            state.tableOptions = tableOptionsToFirstPage(state);
        },
        setTableOptions(state, tableOptions) {
            state.tableOptions = tableOptions;
        },
    },
    getters: {
        dateRange: state => {
            return state.dateRange;
        },
        filterText: state => {
            return state.filterText;
        },
        filterDevice: state => {
            return state.filterDevice;
        },
        filterDoneByUser: state =>{
            return state.filterDoneByUser;
        },
        tableOptions: state => {
            return state.tableOptions;
        },
    },
};
